// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__1VhkT","Label":"Checkbox_Label__2tpmR","InputElement":"Checkbox_InputElement__YlURL","Invalid":"Checkbox_Invalid__3KvkD"};